import { render, staticRenderFns } from "./primaryCategoryDetail.vue?vue&type=template&id=1006a6ca&scoped=true&"
import script from "./primaryCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./primaryCategoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./primaryCategoryDetail.vue?vue&type=style&index=0&id=1006a6ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1006a6ca",
  null
  
)

export default component.exports